import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, autorunAsync, extendObservable } from 'mobx';
import Modal from '../Modal';
import Form, { FormBody, FormActions, SelectInput, TextInput } from '../Form';

@inject('dataSourceStore', 'dataOriginStore', 'dataOriginParameterStore', 'parameterStore', 'parameterUnitStore')
@observer
class DataSourceOriginParameterAdd extends Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  static propTypes = {
    route: PropTypes.shape().isRequired,
  };

  slug;
  @observable dataOrigin = {
    data_source_id: 0,
    code: '',
  };
  @observable dataOriginParameter = {
    code: '',
    parameter_id: '',
    parameter_unit_id: '',
  };
  @observable parameters = [];
  dispose;

  title = 'Add Data Origin Parameter';

  constructor(props) {
    super(props);
    const {
      params: { id, dataOriginId, dataOriginParameterId },
      dataOriginStore, dataOriginParameterStore, parameterStore, parameterUnitStore,
    } = props;
    parameterStore.fetchItems();
    parameterUnitStore.fetchItems();
    this.init();
  }

  @action init = () => {
    const {
      params: { id, dataOriginId, dataOriginParameterId },
      dataOriginStore, parameterStore, dataOriginParameterStore,
    } = this.props;
    this.slug = `/daq/data-source/${id}/data-origin`;
    this.parameters = observable(parameterStore.items);
    this.dispose = autorunAsync(() => {
      this.dataOrigin.data_source_id = id;
      const dataOrigin = dataOriginStore.items.find(item => +item.id === +dataOriginId);
      this.dataOrigin = extendObservable(this.dataOrigin, dataOrigin);
    });
  }

  componentWillMount() {
    const {
      params: { id, dataOriginId },
      dataOriginStore, parameterStore,
    } = this.props;
  }

  componentWillUnmount() {
    this.dispose();
  }

  // @action onChangeCode = (e) => { this.dataOrigin.code = e.target.value; }
  @action onChangeCode = (e) => { this.dataOriginParameter.code = e.target.value; }
  @action onChangeParameter = (e) => {
    this.dataOriginParameter.parameter_id = e.target.value;
    this.dataOriginParameter.parameter_unit_id = this.props.parameterStore.findById(e.target.value).parameter_unit_id;
  }
  @action onChangeParameterUnit = (e) => { this.dataOriginParameter.parameter_unit_id = e.target.value; }

  @action handleSave = (e) => {
    e.preventDefault();

    const { notify } = this.context;
    const { params: { id, dataOriginId, dataOriginParameterId }, dataOriginStore, parameterStore, dataOriginParameterStore, dataSourceStore } = this.props;
    const { code, parameter_id, parameter_unit_id } = this.dataOriginParameter;

    dataOriginParameterStore
      .createItem({ data_origin_id: dataOriginId, code, parameter_id, parameter_unit_id })
      .then((res) => {
        // let new_id = res.filter(param => param.data_origin_id == dataOriginId && param.code == code && param.parameter_id == parameter_id && param.parameter_unit_id == parameter_unit_id)[0].id;
        let originParameter = dataSourceStore.items.filter(ds => ds.id == id)[0].origins.filter(dOrgn => dOrgn.id == dataOriginId)[0].data_origin_parameters;
        let paramter = {
          data_origin_id: dataOriginId, code, id: +res.id, parameter_id, parameter_name: parameterStore.findById(parameter_id).name
        };
        if(!!originParameter) originParameter.push(paramter);
        else originParameter = [paramter];

        this.context.router.push(this.slug);
        notify.success({ message: 'Created Data Origin Parameter' });
      })
      .catch(action((err) => { notify.error(err); }));
  };


  render() {
    const { params: { id, dataOriginId }, dataOriginParameterStore, parameterStore, parameterUnitStore, dataSourceStore } = this.props;
    let selectedParameters = (dataSourceStore.findById(id).origins && dataSourceStore.findById(id).origins.find(i => +i.id === +dataOriginId).data_origin_parameters) || [];

    let remainingParameter = parameterStore.items.filter(item => selectedParameters.map(item => item.parameter_id).indexOf(item.id) === -1);

    return (
      <Modal title={this.title} slug={this.slug} isSaving={dataOriginParameterStore.isSaving} handleSave={this.handleSave} >
        <Form>
          <FormBody>
            <TextInput label={'Code'} value={this.dataOriginParameter.code} onChange={this.onChangeCode} />

            <SelectInput
              label={'Parameter'}
              fields={{ label: 'name', value: 'id' }}
              options={remainingParameter && remainingParameter.sort((a, b) => { return a.name < b.name ? -1 : 1 })}
              onChange={this.onChangeParameter}
              value={this.dataOriginParameter.parameter_id}
              filterOptions={parameterStore.filterParameters}
            />

            <SelectInput
              label={'Parameter Unit'}
              fields={{ label: 'name', value: 'id' }}
              options={parameterUnitStore.items.toJS()}
              onChange={this.onChangeParameterUnit}
              value={this.dataOriginParameter.parameter_unit_id}
            />

          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}


export default DataSourceOriginParameterAdd;



// WEBPACK FOOTER //
// ./src/components/DataSource/DataSourceOriginParameterAdd.js